import Storage from "../../utills/AsyncStorage";
import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  getSingleAssets: [],
  getUploadsAssetColumns: [],
  setAssetsStatus: null,
  getUnlinkAssets: [],
  getPendingAssets: [],
  getVautoAssets: [],

  getUnlinkModules: [],
  getModules: [],
  getModulesPagination: null,
  // setUnlink: null

  getGroupAssets: [],

  setAssetsGroupStatus: null,

  getLorawan: [],

  setStatusOfGroupAsset: null,

  getLicense: [],

  groupAssetDetails: null,
  getGroupVehiclesByGroupID: [],
  getgroupvehicledetails: null,
};

const AssetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_SINGLE_ASSETS:
      state = { ...state, getSingleAssets: action.payload };
      break;

    case ActionTypes.UPLOAD_ASSETE_COLUMNS:
      state = { ...state, getUploadsAssetColumns: action.payload };
      break;

    case ActionTypes.RESET_SINGLE_ASSETS:
      state = { ...state, getSingleAssets: [] };
      break;

    case ActionTypes.SET_ASSETS_STATUS:
      state = { ...state, setAssetsStatus: action.payload };
      break;

    case ActionTypes.GET_UNLINK_ASSETS:
      state = { ...state, getUnlinkAssets: action.payload };
      break;

    case ActionTypes.GET_PENDING_ASSETS:
      state = { ...state, getPendingAssets: action.payload };
      break;

    case ActionTypes.RESET_UNLINK_ASSETS:
      state = { ...state, getUnlinkAssets: [] };
      break;

    case ActionTypes.GET_UNLINK_MODULES:
      state = { ...state, getUnlinkModules: action.payload };
      break;

    case ActionTypes.RESET_UNLINK_MODULES:
      state = { ...state, getUnlinkModules: [] };
      break;

    case ActionTypes.GET_VAUTO_ASSETS:
      state = { ...state, getVautoAssets: action.payload };
      break;

    case ActionTypes.GET_MODULES:
      if (
        state?.getModulesPagination?.meta?.current_page !=
        action.payload?.meta?.current_page
      ) {
        let module_list = [];
        module_list = [...state.getModules, ...action.payload.data];
        state = {
          ...state,
          getModulesPagination: action.payload,
          getModules: module_list,
        };
      }
      break;

    case ActionTypes.RESET_MODULES:
      state = { ...state, getModules: [], getModulesPagination: null };
      break;

    case ActionTypes.DLT_MODULE_FROM_ASSET:
      let singleAsset_list = [...state.getSingleAssets];
      let singleAsset_index = singleAsset_list.findIndex(
        (x) => x.id === action.payload.id,
      );
      singleAsset_list.splice(singleAsset_index, 1);
      state = { ...state, getSingleAssets: singleAsset_list };
      break;

    //Group Assets
    case ActionTypes.GET_GROUP_ASSETS:
      state = { ...state, getGroupAssets: action.payload };
      break;

    case ActionTypes.RESET_GROUP_ASSETS:
      state = { ...state, getGroupAssets: [] };
      break;

    case ActionTypes.SET_ASSETS_GROUP_STATUS:
      state = { ...state, setAssetsGroupStatus: action.payload };
      break;

    case ActionTypes.SET_STATUS_OF_GROUP_ASSET:
      state = { ...state, setStatusOfGroupAsset: action.payload };
      break;

    case ActionTypes.GET_GROUP_VEHICLES_BY_ID: {
      state = {
        ...state,
        getGroupVehiclesByGroupID: action.payload,
      };
    }

    case ActionTypes.GET_GROUP_VEHICLE_DETAILS:
      state = { ...state, getgroupvehicledetails: action.payload };
      break;

    case ActionTypes.GROUP_ASSET_DETAILS:
      const myArray = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      let detail_list = [...myArray];
      let fiterDetail = detail_list.filter((e) => e?.id === action?.id);
      const obj =
        Array.isArray(fiterDetail) && fiterDetail.length === 1
          ? fiterDetail[0]
          : fiterDetail;
      state = { ...state, groupAssetDetails: obj };
      break;

    case ActionTypes.GET_LICENSE:
      state = { ...state, getLicense: action.payload };
      break;
    case ActionTypes.RESET_LICENSE:
      state = { ...state, getLicense: [] };
      break;
    default:
      break;
  }
  return state;
};

export default AssetsReducer;
